"use strict";
// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.areShippingDetailsValid = exports.InvoiceLineItemType = void 0;
// actual string values come from customer-web-server and should be kept in sync with values seen there
exports.InvoiceLineItemType = {
    Full: 'full',
    Partial: 'partial',
    OnPremise: 'onpremise',
    Metered: 'metered',
};
const areShippingDetailsValid = (address) => {
    if (!address) {
        return false;
    }
    return Boolean(address.city && address.country && address.line1 && address.postal_code && address.state);
};
exports.areShippingDetailsValid = areShippingDetailsValid;
